import * as i0 from '@angular/core';
import { Component, ViewEncapsulation, Input, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import * as i1 from '@eui/core';

class EuiDisableContentComponent {
    constructor(elRef, asService) {
        this.elRef = elRef;
        this.asService = asService;
        this.disabledText = '';
        this.lastActiveElement = null;
    }
    get isDisabled() { return this._isDisabled; }
    set isDisabled(value) { this._isDisabled = coerceBooleanProperty(value); }
    ngOnChanges(changes) {
        const activeElement = this.getActiveElement();
        const isBlocking = this.isAboutToBlock(changes);
        if (isBlocking) {
            this.desactivateElement(activeElement);
        }
        else {
            this.reactivateElement(activeElement);
        }
    }
    isAboutToBlock(changes) {
        const isBlockedChange = changes['isDisabled'];
        return isBlockedChange &&
            isBlockedChange.currentValue &&
            !isBlockedChange.previousValue;
    }
    desactivateElement(activeElement) {
        if (activeElement) {
            this.lastActiveElement = activeElement;
        }
        else {
            this.lastActiveElement = null;
        }
    }
    reactivateElement(activeElement) {
        if (this.lastActiveElement) {
            // TODO CHECK
        }
    }
    getActiveElement() {
        return this.elRef.nativeElement.querySelector(':focus');
    }
    onClick(event) {
        if (this.isDisabled && this.disabledText) {
            this.asService.growlInfo(this.disabledText);
        }
    }
}
/** @nocollapse */ EuiDisableContentComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: EuiDisableContentComponent, deps: [{ token: i0.ElementRef }, { token: i1.UxAppShellService }], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ EuiDisableContentComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.0.3", type: EuiDisableContentComponent, selector: "eui-disable-content", inputs: { disabledText: "disabledText", isDisabled: "isDisabled" }, usesOnChanges: true, ngImport: i0, template: "<div [class.eui-disable-content--disabled]=\"isDisabled\"\n    (click)=\"onClick($event)\">\n    <ng-content></ng-content>\n</div>\n", styles: [".eui-disable-content--disabled{position:relative;z-index:var(--eui-base-z-index-overlay)}.eui-disable-content--disabled:before{content:\"\";display:block;height:80px;left:50%;margin:-40px 0 0 -40px;position:absolute;top:50%;width:80px;z-index:10000}.eui-disable-content--disabled:after{background-color:#ffffff40;content:\"\";height:100%;left:0;position:absolute;top:0;width:100%;z-index:100000}\n"], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: EuiDisableContentComponent, decorators: [{
            type: Component,
            args: [{ selector: 'eui-disable-content', encapsulation: ViewEncapsulation.None, template: "<div [class.eui-disable-content--disabled]=\"isDisabled\"\n    (click)=\"onClick($event)\">\n    <ng-content></ng-content>\n</div>\n", styles: [".eui-disable-content--disabled{position:relative;z-index:var(--eui-base-z-index-overlay)}.eui-disable-content--disabled:before{content:\"\";display:block;height:80px;left:50%;margin:-40px 0 0 -40px;position:absolute;top:50%;width:80px;z-index:10000}.eui-disable-content--disabled:after{background-color:#ffffff40;content:\"\";height:100%;left:0;position:absolute;top:0;width:100%;z-index:100000}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i1.UxAppShellService }]; }, propDecorators: { disabledText: [{
                type: Input
            }], isDisabled: [{
                type: Input
            }] } });
class EuiDisableContentModule {
}
/** @nocollapse */ EuiDisableContentModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: EuiDisableContentModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ EuiDisableContentModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.0.3", ngImport: i0, type: EuiDisableContentModule, declarations: [EuiDisableContentComponent], imports: [CommonModule], exports: [EuiDisableContentComponent] });
/** @nocollapse */ EuiDisableContentModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: EuiDisableContentModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: EuiDisableContentModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    exports: [EuiDisableContentComponent],
                    declarations: [EuiDisableContentComponent]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { EuiDisableContentComponent, EuiDisableContentModule };
